
<template>
<div class="val_box">
        <img src="../../assets/m/index/tu7.png" />
        <div class="val_tit">
          <!-- <div>{{ nextDuring }} H</div> -->
          <div class="times notranslate">
            {{ theTime2 }} h {{ theTime1 }} m {{ theTime }} s
          </div>
          <div>To the next bonus era</div>
        </div>
      </div>
 
</template>

<script>
import { GetHomeData } from "../../assets/server/api.js";
export default {
  props: ["tpsCount"],
  data() {
    return {
      value: "",
      totalFlux: 0,
      validators: 0,
      stakePercent: 0,
      awardPercent: 0,
      maxGas: 0,
      nextDuring: 0,
      allNodes: 0,
      Time: null,
      theTime: 0, 
      theTime1: 0, 
      theTime2: 0,
      burn: 0, 
      tpsCounts: 0, 
    };
  },
  watch: {
    deep: true,
    tpsCount(val) {
      this.tpsCounts = val;
    },
  },
  created() {},
  mounted() {
    this.shouye();
    this.daojishi();
  },
  beforeDestroy() {
    if (this.Time) {  
      clearInterval(this.Time);
    }
  },
  methods: {
    async shouye() {
      const res = await GetHomeData();
      this.nextDuring = res.result.nextDuring / 1000;
    },
    daojishi() {   
      this.Time = setInterval(async () => {    
        this.nextDuring--;
        this.theTime = parseInt(this.nextDuring); // 
        this.theTime1 = 0; // 
        this.theTime2 = 0; // 
        if (this.theTime > 60) {
          this.theTime1 = parseInt(this.theTime / 60);
          if (this.theTime > 1) {
            this.theTime = parseInt(this.theTime % 60);
          } else {
            this.theTime = 60;
          }
          if (this.theTime1 > 60) {
            this.theTime2 = parseInt(this.theTime1 / 60);
            if (this.theTime1 > 1) {
              this.theTime1 = parseInt(this.theTime1 % 60);
            } else {
              this.theTime1 = 60;
            }
            if (this.theTime2 > 24) {   
              this.theTime2 = parseInt(this.theTime2 % 24);
            }
          }
        }
      }, 1000);
      
    },
  },
};
</script>

<style lang="less" scoped>
.index_validators {
  width: 750px;
  // height: 572px;
  background: #000;
  margin: 0 auto;
  .validators_c {
    width: 708px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    .val_box {
      width: 334px;
      // height: 140px;
      background: #232a35;
      margin: 8px;
      border-radius: 16px 16px 16px 16px;
      opacity: 1;
      display: flex;
      align-items: center;

      img {
        width: 72px;
        height: 72px;
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
        margin-left: 24px;
      }
      .val_tit {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 22px;
        .times {
          text-align: left;
          font-size: 28px !important;
        }
        div:nth-child(1) {
          margin-top: 24px;
          font-size: 32px;
          // font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.9);
          line-height: 48px;
          height: 48px;
        }
        div:nth-child(2) {
          font-size: 24px;
          font-family: SF Pro Text-Medium, SF Pro Text;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.55);
          line-height: 40px;
          text-align: left;
          margin-bottom: 24px;
        }
      }
    }
  }
}
</style>
